export default __webpack_public_path__ + "locales/de/SmartBanner.json?hash=d7e58838935353362694acd05404d538";